export default "__VITE_ASSET__cgGMXlBn__"